import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCNsPPgIUl_Pe1X7ER2nTXleV879JLgIJ0",
  authDomain: "klickit-cacbf.firebaseapp.com",
  projectId: "klickit-cacbf",
  storageBucket: "klickit-cacbf.firebasestorage.app",
  messagingSenderId: "403693808371",
  appId: "1:403693808371:web:eb713a288989008a2fe586",
  measurementId: "G-YRJ4MCLWVC"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
